import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SttTimetablePiece from './SttTimetablePiece';

type Facility = {
    id?: number;
    name?: string;
    status?: string;
};

type Piece = {
    ini: string;
    end: string;
    duration: number;
    mark: string;
    title?: string;
    price?: number;
    capacity?: {
        free: number;
        total: number;
    };
    bookings?: { id: number; name?: string }[];
    percentagePaid?: number;
    isGame?: boolean;
    isGamePublic?: boolean;
    fixed?: boolean;
    notes?: string;
    players?: { id: number; name: string; img: { uri: string } }[];
    privilegesData?: unknown;
    timetableRates?: unknown;
    priceShape?: { currency?: string; locale?: string };
};

type Column = {
    facility: Facility;
    pieces: Piece[];
};

type Props = {
    column: Column;
    onOpenPiece: (column: Column, piece: Piece) => void;
    width: number;
};

/**
 * Timetable column
 * ================
 */
export default function SttTimetableColumn({
    column,
    onOpenPiece,
    width,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Box
            className={`column ${
                column.facility && column.facility.status === 'ONLY_SC'
                    ? 'onlySC'
                    : ''
            }`}
            style={{ width }}
        >
            {(column.pieces ?? []).map((piece: any, idx: any) => (
                <SttTimetablePiece
                    key={idx}
                    column={column}
                    piece={piece}
                    onOpenPiece={onOpenPiece as any}
                />
            ))}

            {(column.pieces ?? []).length === 0 && (
                <Box className="na">{t('timetable.noAvailable')}</Box>
            )}
        </Box>
    );
}
